/*LIBRARY*/
import { Component } from "react";
import { connect } from "react-redux";
import {
  Grid,
  Tooltip,
  Typography,
  IconButton,
  TextField,
  Dialog,
  List,
  ListItem,
  Button,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import ListAltIcon from "@material-ui/icons/ListAlt";
import TimelineIcon from "@material-ui/icons/Timeline";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TodayIcon from "@material-ui/icons/Today";
import CameraAltIcon from "@material-ui/icons/CameraAlt";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import { CSVLink } from "react-csv";

/*COMPONENT*/
import ChartNew from "./ChartTemplate";

/*REDUX*/
import {
  brantasGetDataByPos,
  getAllDatasetv3,
  getCilicisByPos,
  getDetailItem,
} from "../../App/actions/iotActions";

/*PICTURE*/
import icon_full_screen_active from "../../Assets/svg/icon_full_screen_active.svg";

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

class IotTable extends Component {
  state = {
    tabs: "table",

    sensor: [{ name_sensor: "-", unit: "-" }],
    iotData: [],
    iotDataTimeUnix: [],

    csvData: [],

    filterId: `${this?.props?.geo_layer?.geo_layer?.filtered_features?.[0]?.key}`,
    startDate: `${this.formatDate(new Date())}`,
    finishDate: `${this.formatDate(new Date())}`,

    cilicis: false,
    brantas: false,

    value: [],
    inputValue: "",
    dataset: [],

    siaga1: [],
    siaga2: [],
    siaga3: [],
    siaga4: [],

    brantasData: [],

    cilicisCCTV: [],

    fullScreen: true,
    modalDownload: false,
    headerDownload: [],
    dataDownload: [],
    proses: true,

    checkedInterval: 1,
    alert: false,

    cilicisPDA_2023: [],
  };

  async getIoTData() {
    this.setState({ sensor: [], iotData: [], iotDataTimeUnix: [] });
    const d = await getAllDatasetv3({
      id: this.state.filterId,
      startDate: this.state.startDate,
      finishDate: this.state.finishDate,
    });

    const sensor = d.log_data_v3;
    if (sensor.length > 0) {
      this.setState({ sensor });
    } else if (sensor.length === 0) {
      this.setState({
        sensor: [{ name_sensor: "Belum ada Data", unit: "-" }],
      });
    }

    const ioTdata = d.IoTData;
    if (ioTdata.length > 0) {
      let arr1 = [];
      ioTdata.forEach((element) => {
        this.setState((prevState) => ({
          iotDataTimeUnix: [...prevState?.iotDataTimeUnix, element?.created],
        }));
        const values = element.values;
        let arr2 = [];
        const log_data_v3 = d?.log_data_v3 ? d?.log_data_v3 : [];
        log_data_v3.forEach((e) => {
          let match = values.find((r) => r._id === e._id);
          arr2.push(
            match ? (match.context === "" ? match.data : match.context) : "-"
          );
        });
        arr1.push(arr2);
      });
      const transpose = arr1[0].map((_, colIndex) =>
        arr1.map((row) => row[colIndex])
      );
      this.setState({ iotData: transpose });
      this.setState({
        siaga1: Array.from(Array(ioTdata.length), (_, x) => 350),
        siaga2: Array.from(Array(ioTdata.length), (_, x) => 270),
        siaga3: Array.from(Array(ioTdata.length), (_, x) => 200),
      });
    } else if (ioTdata.length === 0) {
      this.setState({ iotData: [] });
    }
  }

  async getCilicis() {
    this.setState({ sensor: [], iotData: [], iotDataTimeUnix: [] });
    const item = await getDetailItem({ id: this.state.filterId });
    if (item) {
      const d = await getCilicisByPos({
        nama_lokasi: item.context.content.nama_lokasi,
        startDate: this.state.startDate,
        finishDate: this.state.finishDate,
      });
      const arrData = [],
        arrTime = [],
        arrStatus = [],
        siaga1 = [],
        siaga2 = [],
        siaga3 = [];

      let kalibrasi = 0;
      if (this.props.iot.lastDataPDA.list) {
        const listPos = this.props.iot.lastDataPDA.list;
        const findPos = listPos.find(
          (x) => x.nama_lokasi === item.context.content.nama_lokasi
        );
        if (findPos) {
          kalibrasi = parseInt(findPos.kalibrasi);
        }
      }

      d.data_telemetryjakarta &&
        d.data_telemetryjakarta.forEach((e) => {
          arrData.push(parseInt(e.WLevel) + parseInt(kalibrasi));
          if (
            parseInt(item.context.content.siaga1) === 1000 &&
            parseInt(item.context.content.siaga2) === 1000 &&
            parseInt(item.context.content.siaga3) === 1000
          ) {
            arrStatus.push("-");
          } else if (item.context.content.id_tipe === "PCH") {
            arrStatus.push("-");
          } else {
            // parseInt(e.WLevel) >= item.context.content.siaga4 &&
            if (parseInt(e.WLevel) <= item.context.content.siaga3) {
              arrStatus.push("Normal");
            }
            if (
              parseInt(e.WLevel) >= item.context.content.siaga3 &&
              parseInt(e.WLevel) <= item.context.content.siaga2
            ) {
              arrStatus.push("Siaga 3");
            }
            if (
              parseInt(e.WLevel) >= item.context.content.siaga2 &&
              parseInt(e.WLevel) <= item.context.content.siaga1
            ) {
              arrStatus.push("Siaga 2");
            }
            if (parseInt(e.WLevel) >= item.context.content.siaga1) {
              arrStatus.push("Siaga 1");
            }
          }
          arrTime.push(
            new Date(`${e.ReceivedDate} ${e.ReceivedTime}`).getTime()
          );
          siaga1.push(parseInt(item.context.content.siaga1));
          siaga2.push(parseInt(item.context.content.siaga2));
          siaga3.push(parseInt(item.context.content.siaga3));
        });

      this.setState({
        sensor: [
          { name_sensor: "Tinggi Muka Air", unit: "cm" },
          { name_sensor: "Status", unit: "-" },
        ],
        iotData: [arrData, arrStatus],
        iotDataTimeUnix: arrTime,
        siaga1,
        siaga2,
        siaga3,
      });
    }
  }

  async getCilicis2023() {
    const { value, dataset: datasets } = this.state;
    const dataset = datasets.find((e) => e.dataset === value.dataset);
    const { nama_lokasi, id_tipe, siaga1, siaga2, siaga3, siaga4 } =
      dataset.properties;

    const d = await getCilicisByPos({
      nama_lokasi: nama_lokasi,
      startDate: this.state.startDate,
      finishDate: this.state.finishDate,
    });
    if (id_tipe === "PDA") {
      let pda_result = [];
      if (d.data_telemetryjakarta) {
        d.data_telemetryjakarta.forEach((element) => {
          if (parseFloat(element.WLevel) > parseFloat(siaga3)) {
            pda_result.push({ ...element, status: "Siaga 3" });
          } else if (parseFloat(element.WLevel) > parseFloat(siaga2)) {
            pda_result.push({ ...element, status: "Siaga 2" });
          } else if (parseFloat(element.WLevel) > parseFloat(siaga1)) {
            pda_result.push({ ...element, status: "Siaga 1" });
          } else {
            pda_result.push({ ...element, status: "Normal" });
          }
        });
        this.setState({
          cilicisPDA_2023: pda_result,
          siaga1: parseFloat(siaga1),
          siaga2: parseFloat(siaga2),
          siaga3: parseFloat(siaga3),
          siaga4: parseFloat(siaga4),
        });

        this.setState({
          csvData: pda_result.map((e) => ({
            Date: e.ReceivedDate,
            Time: e.ReceivedTime,
            "Water Level": e.WLevel,
            Status: e.status,
          })),
        });
      } else {
        alert(`${d.message} - coba pilih sensor lain.`);
      }
    }
  }

  async getBrantas() {
    if (this.props.iot.brantasLastDataPDA.length > 0) {
      const listPos = this.props.iot.brantasLastDataPDA;
      let arrPos = [];
      listPos.forEach((element) => {
        arrPos.push({
          dataset: element.pos.name.toUpperCase(),
          key: element.pos.id,
        });
      });
      this.setState({ dataset: arrPos });
    }
  }

  componentDidMount() {
    const { layer_id, geo_layer_list } = this.props.layer;
    const geo_layer = geo_layer_list.find((l) => l.geo_layer._id === layer_id);
    const type_2 = geo_layer?.geo_layer?.type_2;

    if (type_2 === "pda" || type_2 === "pch") {
      this.setState({ cilicis: true });
      let dataset = [];

      const features = geo_layer?.geo_layer?.geojson_filtered?.features
        ? geo_layer?.geo_layer?.geojson_filtered?.features
        : [];
      features.forEach((d) => {
        dataset.push({
          key: d?.key,
          dataset: d?.properties?.nama_alat?.toUpperCase(),
          properties: d?.properties,
        });
      });

      this.setState({ dataset, value: dataset[0] });
    } else {
      this.setState({ brantas: true });
      this.getBrantas();
    }
  }

  formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }

  handleChangeOptions = (event) => {
    const index = event.target.selectedIndex;
    const idDataset = event.target.childNodes[index].id;

    this.setState({ filterId: idDataset });
  };

  handleStarDate = (e) => {
    this.setState({ startDate: e.target.value });
  };
  handleFinishDate = (e) => {
    this.setState({ finishDate: e.target.value });
  };

  handleSubmit = () => {
    const findCCTV = this.props.iot.cilicisCCTV.find(
      (x) => x.nama_lokasi === `${this.state.inputValue}`
    );
    if (findCCTV) {
      this.setState({ cilicisCCTV: findCCTV.url });
    } else {
      this.setState({ cilicisCCTV: [] });
    }

    this.getCilicis2023();
  };

  handleSubmitBrantas = () => {
    if (
      this.props.iot.brantasLastDataPDA.length > 0 &&
      this.state.inputValue !== ""
    ) {
      const listPos = this.props.iot.brantasLastDataPDA;
      const index = this.state.filterId;

      const data = listPos.find((x) => x.pos.id === parseInt(index));
      const pos = data.pos;
      let listDataBrantas = [];
      let idx = 0;
      pos.sensors.forEach(async (e) => {
        let sensor = "";

        if (pos.slug === "bangsal") {
          switch (e.name) {
            case "WL":
              sensor = "rain";
              break;
            case "FLOW":
              sensor = "hour";
              break;
            case "BATT":
              sensor = "batt";
              break;
            default:
              break;
          }
        } else if (pos.slug === "bendorejo") {
          switch (e.name) {
            case "WL":
              sensor = "wl";
              break;
            case "FLOW":
              sensor = "flow";
              break;
            case "BATT":
              sensor = "batt";
              break;
            case "CAM":
              sensor = "cam";
              break;
            default:
              break;
          }
        } else if (pos.slug === "dinoyo") {
          switch (e.name) {
            case "WL":
              sensor = "rain";
              break;
            case "FLOW":
              sensor = "hour";
              break;
            case "BATT":
              sensor = "batt";
              break;
            default:
              break;
          }
        } else {
          switch (e.name) {
            case "WL":
              sensor = "awlr";
              break;
            case "FLOW":
              sensor = "flow";
              break;
            case "BATT":
              sensor = "batt";
              break;
            default:
              break;
          }
        }

        if (sensor !== "" && sensor !== "cam") {
          const detailData = await brantasGetDataByPos({
            pos: pos.slug,
            sensor: sensor,
            start: `${this.state.startDate}T00:00`,
            end: `${this.state.finishDate}T23:59`,
          });
          if (!detailData.msg) {
            listDataBrantas.push(detailData);
          }
        }

        if (idx === pos.sensors.length - 1) {
          this.setState({ brantasData: listDataBrantas });
        }
        idx++;
      });
    }
  };

  changeTime(params) {
    const a = new Date(params);
    const jam = a.getHours() < 10 ? `0${a.getHours()}` : a.getHours();
    const menit = a.getMinutes() < 10 ? `0${a.getMinutes()}` : a.getMinutes();
    const detik = a.getSeconds() < 10 ? `0${a.getSeconds()}` : a.getSeconds();
    return `${jam}:${menit}:${detik}`;
  }

  changeDate(params) {
    const a = new Date(params);
    const bulan = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "Mei",
      "Jun",
      "Jul",
      "Agu",
      "Sep",
      "Okt",
      "Nov",
      "Des",
    ];
    const tanggal = a.getDate() < 0 ? `0${a.getDate()}` : a.getDate();
    return `${tanggal} ${bulan[a.getMonth()]} ${a.getFullYear()}`;
  }

  activateFullTable = () => {
    if (this.state.fullScreen) {
      const tableFull = document.getElementById("tableBar");
      tableFull.style.top = "0px";
      tableFull.style.height = "100%";
      tableFull.style.zIndex = "999";
      this.setState({ fullScreen: !this.state.fullScreen });
    } else {
      const tableFull = document.getElementById("tableBar");
      tableFull.style.top = "auto";
      tableFull.style.height = "400px";
      tableFull.style.zIndex = "1";
      this.setState({ fullScreen: !this.state.fullScreen });
    }
  };

  chooseInterval = (e) => {
    this.setState({ checkedInterval: e });
  };

  downloadData = () => {
    this.setState({ alert: false });
    if (this.state.inputValue === "" || this.state.brantasData.length === 0) {
      this.setState({ alert: true });
    } else {
      const masterData = this.state.brantasData;
      let headers = [{ label: "No", key: "INDEX" }],
        datas = [];
      masterData.forEach((element) => {
        headers.push(
          {
            label: `Tanggal`,
            key: `tanggal-${element.sensor.toUpperCase()}`,
          },
          {
            label: `${element.sensor.toUpperCase()}`,
            key: `${element.sensor.toUpperCase()}`,
          }
        );

        element.data.forEach((e, i) => {
          if (datas[i]) {
            datas[i][`tanggal-${element.sensor.toUpperCase()}`] = e.t;
            datas[i][`${element.sensor.toUpperCase()}`] = e.v;
          } else {
            datas.push({
              [`tanggal-${element.sensor.toUpperCase()}`]: e.t,
              [`${element.sensor.toUpperCase()}`]: e.v,
              INDEX: i + 1,
            });
          }
        });
      });
      this.setState({
        headerDownload: headers,
        dataDownload: datas,
        proses: false,
      });
    }
  };

  style = {
    center: { display: "flex", justifyContent: "center", alignItems: "center" },
    font: { color: "black" },
    fontMobile: { color: "black" },
    input: {
      date: {
        borderTop: "none",
        borderRight: "none",
        borderLeft: "none",
        borderRadius: 0,
      },
    },
    btn: {
      outline: {
        color: "#757575",
        padding: "0.35rem",
        marginLeft: "0.1rem",
        marginRight: "0.1rem",
        cursor: "pointer",
      },
      active: {
        border: "solid 1.8px #2196f3",
        backgroundColor: "#2196f3",
        color: "#fff",
        padding: "0.35rem",
        marginLeft: "0.1rem",
        marginRight: "0.1rem",
        borderRadius: "0.3rem",
        cursor: "pointer",
      },
    },
  };

  // genrateDownload = () => {
  //   let dataDownload = this.state.iotData;
  //   let dataTime = this.state.iotDataTimeUnix;
  //   let downloadExcel = [
  //     dataTime?.map((dt) => {
  //       let tanggal =
  //         "tanggal :" + this.changeDate(dt) + " " + this.changeTime(dt);
  //       return tanggal;
  //     }),
  //     dataDownload[0]?.map((dt) => {
  //       let tinggiAir = "Tinggi Muka Air :" + dt;
  //       return tinggiAir;
  //     }),
  //     dataDownload[1]?.map((dt) => {
  //       let status = "Status :" + dt;
  //       return status;
  //     }),
  //   ];
  //   this.setState({
  //     csvData: downloadExcel,
  //   });
  // };

  render() {
    const language = localStorage?.language ? localStorage?.language : "ina";
    const { csvData, cilicisPDA_2023 } = this.state;
    // const tableRender = (
    //   <Grid container style={{ marginBottom: 25, paddingBottom: 20 }}>
    //     <Grid item sm={3} md={3} lg={2} xl={2}>
    //       <TableContainer>
    //         <Table size="small">
    //           <TableHead>
    //             <TableRow>
    //               <TableCell>
    //                 <span style={{ fontSize: "0.6rem" }}></span>
    //                 <br />
    //                 No.
    //               </TableCell>
    //               <TableCell>
    //                 <span style={{ fontSize: "0.6rem" }}></span>
    //                 <br />
    //               </TableCell>
    //             </TableRow>
    //           </TableHead>
    //           <TableBody>
    //             {this.state.sensor.map((e, idx) => (
    //               <TableRow hover={true} key={idx}>
    //                 <TableCell>{idx + 1}</TableCell>
    //                 <TableCell>
    //                   {e.name_sensor} ({e.unit})
    //                 </TableCell>
    //               </TableRow>
    //             ))}
    //           </TableBody>
    //         </Table>
    //       </TableContainer>
    //     </Grid>
    //     <Grid item sm={9} md={9} lg={10} xl={10}>
    //       <TableContainer>
    //         <Table size="small">
    //           <TableHead>
    //             <TableRow>
    //               {this.state.iotDataTimeUnix.map((d, idx) => (
    //                 <Tooltip
    //                   title={this.changeDate(d) + " " + this.changeTime(d)}
    //                   placement="top-start"
    //                   key={idx}
    //                 >
    //                   <TableCell>
    //                     <span style={{ fontSize: "0.6rem" }}>
    //                       {this.changeDate(d)}
    //                     </span>
    //                     <br />
    //                     <span>{this.changeTime(d)}</span>
    //                   </TableCell>
    //                 </Tooltip>
    //               ))}
    //             </TableRow>
    //           </TableHead>
    //           <TableBody>
    //             {this.state.iotData.map((e1, idx) => (
    //               <TableRow hover={true} key={idx}>
    //                 {e1.map((e2, idx2) => (
    //                   <TableCell key={idx2}>{e2}</TableCell>
    //                 ))}
    //               </TableRow>
    //             ))}
    //           </TableBody>
    //         </Table>
    //       </TableContainer>
    //     </Grid>
    //   </Grid>
    // );

    const tableRender2023 = (
      <div>
        {cilicisPDA_2023.length > 0 && (
          <table style={{ width: "100%", color: "gray" }}>
            <tbody>
              <tr>
                <th style={{ borderBottom: "solid 1px" }}>Tanggal</th>
                {cilicisPDA_2023.map((e, idx) => (
                  <th key={idx} style={{ borderBottom: "solid 1px" }}>
                    <small>{e.ReceivedDate}</small>
                    <br />
                    {e.ReceivedTime}
                  </th>
                ))}
              </tr>
              <tr>
                <th style={{ borderBottom: "solid 1px", whiteSpace: "nowrap" }}>
                  Water Level (cm)
                </th>
                {cilicisPDA_2023.map((e, idx) => (
                  <th
                    key={idx}
                    style={{
                      borderBottom: "solid 1px",
                    }}
                  >
                    {e.WLevel}
                  </th>
                ))}
              </tr>
              <tr>
                <th style={{ borderBottom: "solid 1px" }}>Status</th>
                {cilicisPDA_2023.map((e, idx) => (
                  <th key={idx} style={{ borderBottom: "solid 1px" }}>
                    {e.status}
                  </th>
                ))}
              </tr>
            </tbody>
          </table>
        )}
      </div>
    );

    // const tableBrantas = (
    //   <Grid
    //     container
    //     style={{ marginBottom: 25, paddingBottom: 20 }}
    //     spacing={2}
    //   >
    //     {this.state.brantasData.length > 0 &&
    //       this.state.brantasData.map((e, i) => (
    //         <Grid item sm={12} md={4} lg={4} xl={4} key={i}>
    //           {/* <div>{e.sensor}</div> */}
    //           <TableContainer>
    //             <Table size="small">
    //               <TableHead>
    //                 <TableRow>
    //                   <TableCell>No.</TableCell>
    //                   <TableCell align="center">
    //                     {e.sensor.toUpperCase()}
    //                   </TableCell>
    //                   <TableCell>Tanggal</TableCell>
    //                 </TableRow>
    //               </TableHead>
    //               <TableBody>
    //                 {e.data.map((d, idx) => (
    //                   <TableRow key={idx}>
    //                     <TableCell>{idx + 1}</TableCell>
    //                     <TableCell align="center">{d.v}</TableCell>
    //                     <TableCell>{d.t}</TableCell>
    //                   </TableRow>
    //                 ))}
    //               </TableBody>
    //             </Table>
    //           </TableContainer>
    //         </Grid>
    //       ))}
    //   </Grid>
    // );

    const options = {
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: false,
            },
          },
        ],
        xAxes: [
          {
            type: "time",
            time: {
              displayFormats: {
                quarter: "MMM YYYY",
              },
            },
          },
        ],
      },
    };

    // const graphRender = (
    //   <Grid
    //     container
    //     style={{ marginBottom: 15, paddingBottom: 10, overflow: "auto" }}
    //     wrap="nowrap"
    //   >
    //     {this.state.sensor.map(
    //       (e, idx) =>
    //         // {
    //         e.name_sensor !== "Status" &&
    //         e.name_sensor !== "Debit" && (
    //           <Grid item key={idx} style={{ padding: 15 }} lg={10}>
    //             <ChartNew
    //               type="line"
    //               data={{
    //                 labels: this.state.iotDataTimeUnix,
    //                 datasets: [
    //                   {
    //                     label: `${e.name_sensor} - ${e.unit}`,
    //                     borderColor: "rgba(54, 162, 235, 1)",
    //                     data: this.state.iotData[idx],
    //                     fill: false,
    //                     borderWidth: 2,
    //                     radius: 3,
    //                     hoverRadius: 16,
    //                     hoverBorderWidth: 3,
    //                   },
    //                   {
    //                     label: `Siaga 1`,
    //                     borderColor: "red",
    //                     data: this.state.siaga1,
    //                     fill: false,
    //                     borderWidth: 2,
    //                     radius: 0,
    //                     hoverRadius: 0,
    //                     hoverBorderWidth: 0,
    //                   },
    //                   {
    //                     label: `Siaga 2`,
    //                     borderColor: "yellow",
    //                     data: this.state.siaga2,
    //                     fill: false,
    //                     borderWidth: 2,
    //                     radius: 0,
    //                     hoverRadius: 0,
    //                     hoverBorderWidth: 0,
    //                   },
    //                   {
    //                     label: `Siaga 3`,
    //                     borderColor: "blue",
    //                     data: this.state.siaga3,
    //                     fill: false,
    //                     borderWidth: 2,
    //                     radius: 0,
    //                     hoverRadius: 0,
    //                     hoverBorderWidth: 0,
    //                   },
    //                 ],
    //               }}
    //               options={options}
    //               width={600}
    //               height={150}
    //             />
    //           </Grid>
    //         )
    //       // }
    //     )}
    //   </Grid>
    // );

    const graphRender2023 = (
      <div>
        <ChartNew
          type="line"
          options={options}
          width={600}
          height={150}
          data={{
            labels: cilicisPDA_2023.map(
              (e) => `${e.ReceivedDate} ${e.ReceivedTime}`
            ),
            datasets: [
              {
                label: `Water Level (cm)`,
                borderColor: "rgba(54, 162, 235, 1)",
                data: cilicisPDA_2023.map((e) => parseFloat(e.WLevel)),
                fill: false,
                borderWidth: 2,
                radius: 3,
                hoverRadius: 16,
                hoverBorderWidth: 3,
              },
              {
                label: `Siaga 1`,
                borderColor: "red",
                data: cilicisPDA_2023.map(() => this.state.siaga1),
                fill: false,
                borderWidth: 2,
                radius: 0,
                hoverRadius: 0,
                hoverBorderWidth: 0,
              },
              {
                label: `Siaga 2`,
                borderColor: "yellow",
                data: cilicisPDA_2023.map(() => this.state.siaga2),
                fill: false,
                borderWidth: 2,
                radius: 0,
                hoverRadius: 0,
                hoverBorderWidth: 0,
              },
              {
                label: `Siaga 3`,
                borderColor: "blue",
                data: cilicisPDA_2023.map(() => this.state.siaga3),
                fill: false,
                borderWidth: 2,
                radius: 0,
                hoverRadius: 0,
                hoverBorderWidth: 0,
              },
            ],
          }}
        />
      </div>
    );

    const cctvRender = (
      <Grid
        container
        style={{ marginBottom: 15, paddingBottom: 10, marginLeft: 15 }}
      >
        {this.state.cilicisCCTV.length > 0 ? (
          this.state.cilicisCCTV.map((e) => (
            <Grid item style={{ margin: 15 }} key={e}>
              <iframe
                src={`http://175.106.19.226:8081/cctv/${e}`}
                title={e}
                height="280"
                width="360"
                style={{ border: "none" }}
              />
            </Grid>
          ))
        ) : (
          <Grid item style={{ marginTop: 15, marginLeft: 15 }}>
            <Alert severity="error">
              CCTV Belum Tersedia, Silahkan pilih pos lain.
            </Alert>
          </Grid>
        )}
      </Grid>
    );

    const graphBrantas = (
      <Grid
        container
        style={{ marginBottom: 15, paddingBottom: 10, overflow: "auto" }}
      >
        {this.state.brantasData.length > 0 &&
          this.state.brantasData.map((e, i) => {
            let labels = [],
              datas = [];
            e.data.forEach((e) => {
              labels.push(e.t);
              datas.push(e.v);
            });
            return (
              <ChartNew
                type="line"
                key={i}
                data={{
                  labels: labels,
                  datasets: [
                    {
                      label: `${e.sensor.toUpperCase()}`,
                      borderColor: "rgba(54, 162, 235, 1)",
                      data: datas,
                      fill: false,
                      borderWidth: 2,
                      radius: 3,
                      hoverRadius: 16,
                      hoverBorderWidth: 3,
                    },
                  ],
                }}
                options={options}
                width={600}
                height={150}
              />
            );
          })}
      </Grid>
    );

    const defaultRender = (
      <Grid container spacing={1} style={{ margin: 5, marginBottom: 0 }}>
        <Grid item style={this.style.center}>
          <section className="full_screen" onClick={this.activateFullTable}>
            <img alt="full_screen" src={icon_full_screen_active} width="20px" />
          </section>
        </Grid>
        <Grid item style={this.style.center}>
          <Typography style={this.style.font}>
            PILIH {this.state.brantas && " POS PEMANTAU"}
            {/* {this.state.cilicis &&
              this.props.geo_layer?.geo_layer.name.toUpperCase()} */}
          </Typography>
        </Grid>
        <Grid item style={this.style.center}>
          <Autocomplete
            style={{ width: 260 }}
            options={this.state.dataset}
            getOptionLabel={(option) => (option.dataset ? option.dataset : "")}
            renderInput={(params) => <TextField {...params} size="small" />}
            value={this.state.value}
            onChange={(event, newValue) => {
              newValue &&
                this.setState({ value: newValue, filterId: newValue.key });
            }}
            inputValue={this.state.inputValue}
            onInputChange={(event, newInputValue) => {
              this.setState({ inputValue: newInputValue });
            }}
          />
        </Grid>
        <Grid item style={this.style.center}>
          &bull;
        </Grid>
        <Grid item style={this.style.center}>
          <Tooltip title={`${dict?.["Select Start Date"]?.[language]}`}>
            <TodayIcon />
          </Tooltip>
        </Grid>
        <Grid item>
          <Tooltip title={`${dict?.["Select Start Date"]?.[language]}`}>
            <input
              type="date"
              style={this.style.input.date}
              onChange={this.handleStarDate}
              value={this.state.startDate}
            />
          </Tooltip>
        </Grid>
        <Grid item style={this.style.center}>
          <Tooltip title={`${dict?.["Select End Date"]?.[language]}`}>
            <TodayIcon />
          </Tooltip>
        </Grid>
        <Grid item>
          <Tooltip title={`${dict?.["Select End Date"]?.[language]}`}>
            <input
              type="date"
              style={this.style.input.date}
              onChange={this.handleFinishDate}
              value={this.state.finishDate}
            />
          </Tooltip>
        </Grid>
        {/* button cari */}
        <Grid item style={this.style.center}>
          {this.state.brantas ? (
            <button
              className="button background_black"
              onClick={this.handleSubmitBrantas}
            >
              {dict?.["Search"]?.[language]}
            </button>
          ) : (
            <button
              className="button background_black"
              onClick={this.handleSubmit}
            >
              {dict?.["Search"]?.[language]}
            </button>
          )}
        </Grid>
        <Grid item style={this.style.center}>
          &bull;
        </Grid>
        <Grid item style={this.style.center}>
          {/* <Tooltip title="Refresh Data">
            <IconButton>
              <RefreshIcon />
            </IconButton>
          </Tooltip> */}
          {this.state.cilicis && (
            <>
              <Tooltip title="Lihat Table">
                <IconButton onClick={() => this.setState({ tabs: "table" })}>
                  <ListAltIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Lihat Graph">
                <IconButton onClick={() => this.setState({ tabs: "graph" })}>
                  <TimelineIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Lihat CCTV">
                <IconButton onClick={() => this.setState({ tabs: "cctv" })}>
                  <CameraAltIcon />
                </IconButton>
              </Tooltip>
            </>
          )}
          {this.state.brantas && (
            <Tooltip title="Unduh Data">
              <IconButton
                onClick={() =>
                  this.setState({
                    modalDownload: true,
                    proses: true,
                    alert: false,
                  })
                }
              >
                <CloudDownloadIcon />
              </IconButton>
            </Tooltip>
          )}
          <CSVLink
            filename={`PosDugaAir.csv`}
            data={csvData}
            // headers={this.headers}
            // onClick={(e, done) => {
            //   this.genrateDownload({}, done);
            // }}
          >
            <div className="button background_black">
              {dict?.["Download CSV"]?.[language]}
            </div>
          </CSVLink>
          <p>{this.props.inputValue}</p>
        </Grid>
      </Grid>
    );

    const modalDownload = (
      <Dialog
        open={this.state.modalDownload}
        onClose={() => this.setState({ modalDownload: false })}
      >
        {/* <DialogTitle>Unduh Data</DialogTitle> */}
        <List>
          <ListItem>
            <p>POS: {this.state.inputValue}</p>
          </ListItem>
          <ListItem>
            <p>Tanggal Mulai: {this.state.startDate}</p>
          </ListItem>
          <ListItem>
            <p>Tanggal Akhir: {this.state.finishDate}</p>
          </ListItem>
          <ListItem style={{ paddingBottom: 0 }}>Interval Data:</ListItem>
          <ListItem>
            <div>
              <input
                style={{ width: "auto" }}
                type="radio"
                id="interval1"
                name="interval"
                value="1"
                checked={this.state.checkedInterval === 1 ? true : false}
                onChange={() => this.chooseInterval(1)}
              />
              <label for="interval1">Semua</label>
              <input
                style={{ width: "auto" }}
                type="radio"
                id="interval2"
                name="interval"
                value="2"
                checked={this.state.checkedInterval === 2 ? true : false}
                onChange={() => this.chooseInterval(2)}
                disabled
              />
              <label for="interval2">5 Menit</label>
              <input
                style={{ width: "auto" }}
                type="radio"
                id="interval3"
                name="interval"
                value="3"
                checked={this.state.checkedInterval === 3 ? true : false}
                onChange={() => this.chooseInterval(3)}
                disabled
              />
              <label for="interval3">1 Jam</label>
            </div>
          </ListItem>
          {this.state.proses ? (
            <ListItem>
              <Button
                variant="text"
                fullWidth
                style={{ textDecoration: "underline" }}
                onClick={() => this.downloadData()}
              >
                Proses Data
              </Button>
            </ListItem>
          ) : (
            <ListItem>
              <CSVLink
                data={this.state.dataDownload}
                headers={this.state.headerDownload}
                filename={`${this.state.inputValue}.csv`}
                style={{ textDecoration: "underline", color: "blue" }}
              >
                Unduh Data {this.state.inputValue}
              </CSVLink>
            </ListItem>
          )}
          {this.state.alert && (
            <ListItem>
              <Alert severity="info">
                Silahkan memilih POS terlebih dahulu dan klik Cari
              </Alert>
            </ListItem>
          )}
        </List>
      </Dialog>
    );
    return (
      <div>
        {defaultRender}
        {this.state.tabs === "table" && tableRender2023}
        {this.state.tabs === "graph" && graphRender2023}
        {this.state.tabs === "cctv" && cctvRender}
        {this.state.brantas && graphBrantas}
        {this.state.brantas && modalDownload}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  layer: state.layer,
  iot: state.iot,
  auth: state.auth,
});

export default connect(mapStateToProps, {})(IotTable);

// const dummyDataset = [ {
//   borderColor: [
//     'rgba(54, 162, 235, 1)',
//   ],
//   label: 'label dataset',
//   data: [ 1, 2, 3, 4, 5, 6, 7, 9, 10, 11 ],
// } ];
